import { UserType } from "../../enums/UserType.enum";
import { User } from "../../types/User";
import { EmailVerificationRequest, ForgotPasswordRequest, GoogleAuthRequest, LoginRequest, LoginResponse, RegisterRequest, ResetPasswordRequest, UpdateProfileRequest } from "../types/api-types";
import apiClient from "./client";

// ---- Email Auth ----

// Login with email and password
export const login = async (loginRequest: LoginRequest, language: string): Promise<LoginResponse> => {
    const response = await apiClient.post('/auth/login', loginRequest, {
        headers: {
            'Accept-Language': language
        }
    });
    return response.data;
}

// Register with email and password
export const registerUser = async (registerRequest: RegisterRequest, language: string) => {
    const response = await apiClient.post('/auth/register', { ...registerRequest, userType: UserType.USER }, {
        headers: {
            'Accept-Language': language
        }
    });
    return response.data;
}

// Delete user (requires JWT token)
export const deleteUser = async (language: string) => {
    const response = await apiClient.get('/auth/delete-user', {
        headers: {
            'Accept-Language': language
        }
    });
    return response.data;
}

// Forgot password
export const forgotPassword = async (forgotPasswordRequest: ForgotPasswordRequest, language: string) => {
    const response = await apiClient.post('/auth/forgot-password', forgotPasswordRequest, {
        headers: {
            'Accept-Language': language
        }
    });
    return response.data;
}

// Reset password
export const resetPassword = async (resetPasswordRequest: ResetPasswordRequest, language: string) => {
    const response = await apiClient.post('/auth/reset-password', resetPasswordRequest, {
        headers: {
            'Accept-Language': language
        }
    });
    return response.data;
}

// Send verification email (requires JWT token)
export const sendVerificationEmail = async (language: string) => {
    const user = localStorage.getItem('user-storage')
    const parsedUser = user ? JSON.parse(user) : null
    const headers = parsedUser && parsedUser?.state?.user?.access_token ? {
        'Authorization': `Bearer ${parsedUser.state.user.access_token}`,
        'Accept-Language': language
    } : {
        'Accept-Language': language
    }
    const response = await apiClient.get('/auth/send-verification-email', { headers });
    return response.data;
}

// Verify email
export const verifyEmail = async (emailVerificationRequest: EmailVerificationRequest, language: string) => {
    const response = await apiClient.get('/auth/verify-email', { params: emailVerificationRequest, headers: {
        'Accept-Language': language
    } });
    return response.data;
}

// Check email verification status (requires JWT token)
export const checkEmail = async (language: string) => {
    const response = await apiClient.get('/auth/check-email', {
        headers: {
            'Accept-Language': language
        }
    });
    return response.data;
}

export const getProfile = async (language: string): Promise<User> => {
    const storedUser = localStorage.getItem('user-storage');
    const parsedUser = storedUser ? JSON.parse(storedUser) : null;
    const token = parsedUser?.state?.user?.access_token;

    const headers: Record<string, string> = {
        'Accept-Language': language,
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await apiClient.get('/auth/get-profile', { headers });
    return response.data;
}

export const updateProfile = async (
    payload: UpdateProfileRequest,
    language: string
): Promise<User> => {
    const storedUser = localStorage.getItem('user-storage');
    const parsedUser = storedUser ? JSON.parse(storedUser) : null;
    const token = parsedUser?.state?.user?.access_token;

    const headers: Record<string, string> = {
        'Accept-Language': language,
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await apiClient.patch('/auth/update-profile', payload, { headers });
    return response.data;
}

// ---- Google Auth ----

// Google register
export const googleRegister = async (googleRegisterRequest: GoogleAuthRequest, language: string) => {
    const response = await apiClient.post('/auth/google/register', googleRegisterRequest, {
        headers: {
            'Accept-Language': language
        }
    });
    return response.data;
}

// Google login
export const googleLogin = async (googleLoginRequest: GoogleAuthRequest, language: string) => {
    const response = await apiClient.post('/auth/google/login', googleLoginRequest, {
        headers: {
            'Accept-Language': language
        }
    });
    return response.data;
}


export const checkAuth = async () => {
    const user = localStorage.getItem('user-storage')
    const parsedUser = user ? JSON.parse(user) : null
    const headers = parsedUser && parsedUser?.state?.user?.access_token ? {
        'Authorization': `Bearer ${parsedUser.state.user.access_token}`
    } : {}
    const response = await apiClient.get('/auth/check-auth', { headers });
    return response.data;
}
